// extracted by mini-css-extract-plugin
export default {"ModalImg":"ModalComponent_ModalImg__vEFkU"};